import React from 'react';
type EyebrowTone = 'amber' | 'muted' | 'rose';
interface EyebrowProps {
  children: React.ReactNode;
  tone?: EyebrowTone;
  align?: 'left' | 'center';
}
const toneClasses: Record<EyebrowTone, {
  text: string;
  line: string;
}> = {
  amber: {
    text: 'text-amber',
    line: 'bg-amber'
  },
  muted: {
    text: 'text-cream-muted',
    line: 'bg-cream-muted'
  },
  rose: {
    text: 'text-rose',
    line: 'bg-rose'
  }
};
export function Eyebrow({
  children,
  tone = 'amber',
  align = 'left'
}: EyebrowProps) {
  const colors = toneClasses[tone];
  return <div className={`flex items-center gap-3 ${align === 'center' ? 'justify-center' : ''}`} data-id="element-90" data-mp="16xb3ey9drg9r">
      <span className={`h-px w-8 shrink-0 ${colors.line}`} aria-hidden="true" data-id="element-91" data-mp="sxs7d3tufvdt" />
      <p className={`text-[10px] font-semibold uppercase tracking-label sm:text-[11px] ${colors.text}`} data-id="element-92" data-mp="xvbnyae0kk8x">
        {children}
      </p>
    </div>;
}